<template>
  <div class="popup">

    <transition name="fade">
      <div v-if="userListDialog" class="all-users__have-read">
        <div class="user__list">
          <div
            v-for="(user, index) in usersHaveRead"
            :key="'user' + index"
            class="user__item"
            @click="$router.push(`/user/info/${user.id}/personal`)"
          >
            <div class="user-avatar popup__avatar">
              <img v-if="getUserAvatar(user.id)" :src="getUserAvatar(user.id).url">
              <img v-else src="/img/avatar-thumb.png">
            </div>

            <div v-if="getUserName(user.id)">{{ getUserName(user.id).split(" ").slice(0, 2).reverse().join(" ") }}</div>
          </div>
        </div>
      </div>
    </transition>

    <div class="popup-menu" @click.stop>
      <ul class="popup-menu__list">
        <li v-if="usersHaveRead && usersHaveRead.length" class="users__have-read">
          Просмотрено: {{ usersHaveRead.length }}
          <div class="user__list">
            <div v-for="(user, i) in usersHaveRead.slice(0, 5)" :key="i" style="width: 15px">
              <div class="user-avatar read-user">
                  <img v-if="getUserAvatar(user.id)" :src="getUserAvatar(user.id).url">
                  <img v-else src="/img/avatar-thumb.png" alt="private" />
              </div>
            </div>
<!--  v-if="usersHaveRead.length > 5"  -->
            <button @click="userListDialog = !userListDialog" class="user__list-button">еще</button>
          </div>
        </li>
        <li class="popup-menu__item" v-if="items.select">
          <div class="popup-menu__link" @click="select">
            <p class="popup-menu__text">Выбрать</p>
          </div>
        </li>
        <li class="popup-menu__item" v-if="items.pin">
          <div class="popup-menu__link" @click="pin">
            <p class="popup-menu__text">Закрепить</p>
          </div>
        </li>
        <li class="popup-menu__item" v-if="items.update">
          <div class="popup-menu__link" @click="update">
            <p class="popup-menu__text">Редактировать</p>
          </div>
        </li>
        <li class="popup-menu__item" v-if="items.reply">
          <div class="popup-menu__link" @click="reply">
            <p class="popup-menu__text">Ответить</p>
          </div>
        </li>
        <li class="popup-menu__item" v-if="items.task">
          <div class="popup-menu__link" @click="makeTask">
            <p class="popup-menu__text">В задачу</p>
          </div>
        </li>
        <li class="popup-menu__item" v-if="items.remove">
          <div class="popup-menu__link" @click="remove">
            <p class="popup-menu__text">Удалить</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppPopupMenu',
  props: {
    usersHaveRead: {
      type: Array,
      default: () => []
    },
    items: {
      type: Object,
      default: () => ({
        select: false,
        pin: false,
        update: false,
        reply: false,
        task: false,
        remove: true
      })
    }
  },
  data () {
    return {
      userListDialog: false
    }
  },
  computed: {},
  methods: {
    select () {
      this.$emit('select-item')
    },
    pin () {
      this.$emit('pin-item')
    },
    update () {
      this.$emit('update-item')
    },
    reply () {
      this.$emit('reply-item')
    },
    makeTask () {
      this.$emit('make-task')
    },
    remove () {
      this.$emit('remove-item')
    },
    getUserAvatar (userId) {
      if (this.$store.getters['[dictionaries] usersList']?.length) {
        if (this.$store.getters.getFullUserById(userId)) {
          return this.$store.getters.getFullUserById(userId).avatar
        } else {
          return false
        }
      }
    },
    getUserName (userId) {
      return this.$store.getters.getUserById({ userId })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/system/_vars";
@import "../../../assets/css/system/_mixins";

.popup {
  display: flex;
  column-gap: 2px;
}

.all-users__have-read {
  background-color: $color_main;
  border-radius: 3px;
  width: 231px;
  filter: drop-shadow(0px 4px 20px rgba(23, 63, 125, 0.22));
  padding: 18px 12px 18px 10px;

  .user__list {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    overflow: auto;
    height: 263px;
    width: 100%;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background-color: $color_third;
    }

    &::-webkit-scrollbar-thumb {
      background-color: $color_second-light;
      min-width: 300px;
    }

    .user__item {
      display: flex;
      align-items: center;
      min-height: 40px;
      padding-left: 2px;

      .popup__avatar {
        // min-width: 34px;
        // min-height: 34px;
        // max-width: 34px;
        // max-height: 34px;
        margin-right: 8px;
      }
    }
  }
}

.popup-menu {
  width: 160px;
  position: relative;
  color: $font_color_main;
  background-color: $color_main;
  border: 1px solid $border_color;
  border-radius: 3px;
  box-shadow: 0px 4px 4px rgba(17, 112, 184, 0.25);

  &__link {
    display: flex;
    // justify-content: center;
    align-items: center;
    padding: 12px 17px;
    min-height: 44px;
    cursor: pointer;
    transition: 0.3s;
    user-select: none;

    &:hover {
      color: $color_second-light;
    }
  }

  &__text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:before {
    content: "";
    display: block;
    position: absolute;
    z-index: 999;
    top: calc(50% - 5px);
    left: auto;
    right: -6px;
    width: 10px;
    height: 10px;
    background: linear-gradient(
      -45deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0) 50%,
      $color_main 50%,
      $color_main 100%
    );
    border: 1px solid $border_color;
    border-bottom: none;
    border-right: none;
    transform: rotate(135deg);
  }

  .users__have-read {
    padding: 14px 17px 13px;
    border-bottom: 1px solid #c4c4c4;
    color: #697178;
    cursor: default;

    .user__list {
      display: flex;
      margin-top: 7px;

      .read-user {
        min-width: 19px;
        min-height: 19px;
        max-width: 19px;
        max-height: 19px;
      }

      .user__list-button {
        margin-left: 7px;
        color: #0E619F;
      }
    }
  }
}
</style>
